import { render, staticRenderFns } from "./ChewerList.vue?vue&type=template&id=5d1d604f&scoped=true&"
import script from "./ChewerList.vue?vue&type=script&lang=js&"
export * from "./ChewerList.vue?vue&type=script&lang=js&"
import style0 from "./ChewerList.vue?vue&type=style&index=0&id=5d1d604f&prod&lang=css&"
import style1 from "./ChewerList.vue?vue&type=style&index=1&id=5d1d604f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1d604f",
  null
  
)

export default component.exports